// apps/console/src/services/api/sos-answer-notices.ts
//
// Why an operator's answer to an emergency did not go through, by alert.
//
// Module-level because the surface that held the button can be gone by the time the server replies.
// An answer takes its card or row off the screen on the click, and when it was the last one the list
// unmounts with it. When the server refuses, the alarm comes back, and its reason has to be there
// waiting beside it, not lost with the component that asked.

type Listener = () => void

const listeners = new Set<Listener>()
let notices: ReadonlyMap<string, string> = new Map()

function replace(next: Map<string, string>): void {
  // A NEW map on every change: `useSyncExternalStore` re-renders on a changed reference, and only then.
  notices = next
  listeners.forEach(l => l())
}

export function setSosAnswerNotice(alertId: string, message: string): void {
  replace(new Map(notices).set(alertId, message))
}

/** Called when the operator tries again, so an old reason never sits beside a new attempt. */
export function clearSosAnswerNotice(alertId: string): void {
  if (!notices.has(alertId)) return

  const next = new Map(notices)

  next.delete(alertId)
  replace(next)
}

/** The current notices. The same reference until something changes. */
export function readSosAnswerNotices(): ReadonlyMap<string, string> {
  return notices
}

export function subscribeSosAnswerNotices(listener: Listener): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function __resetSosAnswerNoticesForTests(): void {
  listeners.clear()
  notices = new Map()
}
